import { render, staticRenderFns } from "./LinkageModuleTN.vue?vue&type=template&id=6c6ee816&scoped=true&"
import script from "./LinkageModuleTN.vue?vue&type=script&lang=js&"
export * from "./LinkageModuleTN.vue?vue&type=script&lang=js&"
import style0 from "./LinkageModuleTN.vue?vue&type=style&index=0&id=6c6ee816&prod&lang=scss&scoped=true&"
import style1 from "./LinkageModuleTN.vue?vue&type=style&index=1&id=6c6ee816&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6ee816",
  null
  
)

export default component.exports